'use client';
import React from 'react';
import { useUI } from '@/app/context/UIContext';
import { useAuth } from '@/hooks/useAuth';
import { useRouter, usePathname } from 'next/navigation';

export default function Header() {
  const { onOpenDati, onOpenImpostazioni } = useUI();
  const { user, signOut } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  const today = new Date();
  const dateStr = today.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Reload completo invece di router.push: evita che lo stato client
      // residuo di pagine "pesanti" (es. simulazione) blocchi silenziosamente
      // la transizione soft di Next.js verso la home dopo il logout.
      window.location.href = '/';
    }
  };

  const isRazionale = pathname === '/landing/razionale';
  const isNewHome = pathname === '/newhome';

  const isAuthPage = pathname === '/login' || pathname === '/signup' || pathname === '/accesso-scaduto';

if (isAuthPage) return null;

  return (
    <header className="topbar">
      {isRazionale ? (
        <button className="iconbtn" aria-label="Indietro" title="Indietro" onClick={() => router.back()}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
      ) : isNewHome ? (
        // Pagina di test: nessun link di navigazione a sinistra
        <div className="flex items-center gap-1" aria-hidden="true" />
      ) : (
        <div className="flex items-center gap-1">
          <a
            href="/newhome"
            className={`text-sm font-bold transition px-2 py-1 ${pathname === '/newhome' ? 'text-orange-500' : 'text-slate-500 hover:text-orange-400'}`}
          >
            Home
          </a>
          <a
            href="/simulazione"
            className={`text-sm font-bold transition px-2 py-1 ${pathname.startsWith('/simulazione') ? 'text-orange-500' : 'text-slate-500 hover:text-orange-400'}`}
          >
            Simul.
          </a>
        </div>
      )}
      <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 pointer-events-none">
        <span className="font-bold text-xl whitespace-nowrap tracking-tight">
          <span className="text-orange-500">39</span>
          <span className="text-slate-900 dark:text-white">40</span>
        </span>
        <span className="text-slate-400 text-xs whitespace-nowrap">
          {dateStr}
        </span>
      </div>
      {!isRazionale && (
        <div className="flex items-center gap-2 ml-auto">

          {onOpenImpostazioni && (
            <button className="iconbtn" aria-label="Impostazioni" onClick={onOpenImpostazioni} title="Impostazioni">
              ⚙️
            </button>
          )}
          {user && (
            <button
              onClick={handleSignOut}
              className="text-sm font-bold text-orange-500 hover:text-orange-400 transition px-2 py-1"
              title="Esci"
            >
              Esci
            </button>
          )}
        </div>
      )}
    </header>
  );
}